// import { UtmParams, UtmParamKeys } from '@grammarly/website-components'
// import { CDN_URL } from '../../constants'
import { getConfig } from '@config/index'
// import { getLogger } from '@lib/tracking/felog/telemetry'
// import { transformToObject } from './error'

export const invalidQueryKeys = ['__nextLocalePatch', 'pid']

export type QueryValue = string | string[] | number | number[] | boolean | boolean[]

export type QueryParams<T = QueryValue> = { [key: string]: T }
export type OptionalQueryParams = QueryParams<QueryValue | undefined>

const isValidQueryValue = (value: QueryValue | undefined): value is QueryValue => value != null

const isValidQueryKey = (key: string) => !invalidQueryKeys.includes(key)

const { basePath } = getConfig().paths

// const utmParameters: UtmParamKeys[] = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

export const composeCMSRelativeHref = (path: string, isPreview?: boolean) => {
  // @TODO: This is a temporary fix, we need to move this function
  // out of ui-core/link so that it's not overriding all <Button>
  // and other components. Slack thread here:
  // https://grammarly.slack.com/archives/C09D41E20UQ/p1760110968065569
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`
  return isPreview ? `/preview/slug${pathWithLeadingSlash}` : path
}

export const composeUrl = (url: string, params: OptionalQueryParams = {}): string => {
  if (!url) {
    return 'about:blank'
  }
  if (url?.startsWith('#')) {
    return url
  }
  try {
    const urlObject = new URL(url, basePath)
    return appendQueryParams(urlObject, params)
  } catch (error) {
    console.error('Could not compose URL and append query parameters', error)
    // getLogger('cms.composeUrl').warn('Could not compose URL and append query parameters', {
    //   error: transformToObject(e as Error),
    //   url,
    //   params,
    // })
    // TODO: implement error handling for url composition
  }
  return basePath
}

export const appendQueryParams = (urlObject: URL, queryParams: OptionalQueryParams) => {
  for (const key of Object.keys(queryParams)) {
    const value = queryParams[key]
    if (isValidQueryValue(value) && isValidQueryKey(key)) {
      if (Array.isArray(value)) {
        for (const v of value) {
          urlObject.searchParams.append(key, v.toString())
        }
      } else {
        urlObject.searchParams.append(key, value.toString())
      }
    }
  }
  return urlObject.href
}

// const isUtmParamKey = (key: string): key is UtmParamKeys => {
//   return utmParameters.some((k) => k === key)
// }

// const extractUtmParamsFromQueryObject = (queryParams: OptionalQueryParams): UtmParams => {
//   return Object.entries(queryParams).reduce((acc, [key, value]) => {
//     if (typeof value === 'string' && isUtmParamKey(key) && value) {
//       return {
//         ...acc,
//         [key]: value,
//       }
//     }
//     return acc
//   }, {})
// }

// const extractUtmParamsFromURLSearchObject = (queryParams: URLSearchParams): UtmParams => {
//   const utmParams: { [key: string]: string } = {}

//   queryParams.forEach((value, key) => {
//     if (isUtmParamKey(key) && value) {
//       utmParams[key] = value as string
//     }
//   })

//   return utmParams
// }

// export const extractUtmParams = (queryParams: OptionalQueryParams | URLSearchParams): UtmParams => {
//   return queryParams instanceof URLSearchParams
//     ? extractUtmParamsFromURLSearchObject(queryParams)
//     : extractUtmParamsFromQueryObject(queryParams)
// }

// /**
//  * This function is a type-safe way to convert FormData to URLSearchParams.
//  * https://github.com/microsoft/TypeScript/issues/30584
//  */
// export const convertFormDataToUrlSearchParams = (formData: FormData): URLSearchParams => {
//   const convertedFormEntries = Array.from(formData, ([key, value]) => [
//     key,
//     typeof value === 'string' ? value : value.name,
//   ])
//   return new URLSearchParams(convertedFormEntries)
// }

// export const getCurrentLocation = () => {
//   if (typeof window !== 'undefined') {
//     return window.location.href
//   }
//   return ''
// }

// /** Returns the Contentful slug without leading or trailing slashes, and converts to unique slugs like `homepage` */
// export const getSlugFromStaticPathname = (path: string) => {
//   // This allows the bundle to get the correct structure when testing directly on the cdn `https://static-web.grammarly.com/static-fallback/<PAGE>`
//   const bucketSubpath = '/static-fallback'
//   if (path.startsWith(bucketSubpath)) {
//     path = path.slice(bucketSubpath.length)
//   }
//   if (path.endsWith('/')) {
//     path = path.slice(0, path.length - 1)
//   }
//   if (path.startsWith('/')) {
//     path = path.slice(1)
//   }
//   if (path === '') {
//     path = 'homepage'
//   }
//   return path
// }

// export const getStructureFilePath = (path: string) => CDN_URL + '/cms-page-data/' + path + '.json.gz'
